export var TRAKR_SERVER = process.env.NEXT_PUBLIC_TRAKR_SERVER;
export var SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export var GTM_ID = 'GTM-P3KK26G';
export var NODE_ENV = "production";
export var DEV_HOST = process.env.NEXT_PUBLIC_HOST;
export var AMPLI_ENV = process.env.NEXT_PUBLIC_AMPLI_ENV;
export var AMPLI_SOURCE_ENV = process.env.NEXT_PUBLIC_AMPLI_SOURCE_ENV;